import preInvoice from '@/api/pre-invoice'
import feeType from '@/api/fee-type'
import term from '@/api/term-semester'
import grade from '@/api/grade'
import studentEnrol from '@/api/student-enrollment'
import subProgram from '@/api/sub-program'
import level from '@/api/level'
import moment from 'moment'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  room_type_id: null,
  branch_id: null,
  feeTypes: [],
  showData: {},
  feeSetups: [],
  date_from: moment().format('DD-MM-YYYY'),
  date_to: moment().format('DD-MM-YYYY')
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_FEE_TYPE (state, feeType) {
    state.feeTypes = feeType
  },
  SET_SHOW_DATA (state, data) {
    state.showData = data
  },
  SET_DATE_FROM (state, date) {
    state.date_from = date
  },
  SET_DATE_TO (state, date) {
    state.date_to = date
  },
  SET_ROOM_TYPE_ID (state, id) {
    state.room_type_id = id
  },
  SET_BRANCH_ID (state, data) {
    state.branch_id = data
  }
}

export const actions = {
  fetch (context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        date_from: context.state.date_from,
        date_to: context.state.date_to,
        all_branch: Array.isArray(context.state.branch_id)
          ? context.state.branch_id.length
            ? undefined
            : true
          : true
      },
      attrubutes
    )
    return preInvoice.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  async find (context, id) {
    if (_.isEmpty(context.state.showData)) {
      let response = await preInvoice.find(id)
      context.commit('SET_SHOW_DATA', response.data)
    }
  },
  store (context, data) {
    return preInvoice.store(data)
  },
  destroy (context, { id, data }) {
    return preInvoice.destroy(id, data)
  },
  async getFeeType (context, attrubutes = {}) {
    let response = await feeType.get({ params: attrubutes })
    context.commit('SET_FEE_TYPE', response.data)
  },
  getStudent (context, attrubutes = {}) {
    return studentEnrol.get({ params: attrubutes })
  },
  getStudentSubscripton (context, data) {
    return preInvoice.studentSubscript(data)
  },
  getAcademicTerm (context, attrubutes = {}) {
    return term.get({ params: attrubutes })
  },
  getGradeByLevel (context, attrubutes = {}) {
    return grade.get({ params: attrubutes })
  },
  getFeeSetupWithDetail (context, data) {
    return preInvoice.getFeeSetupWithDetail(data)
  },
  printPDF (context, { id }) {
    return preInvoice.printPDF(id)
  },
  getSubProgram (context, attrubutes = {}) {
    return subProgram.get({ params: attrubutes })
  },
  getLevel (context, attrubutes = {}) {
    return level.get({ params: attrubutes })
  },
  printByGrade (context, data) {
    return preInvoice.printByGrade(data)
  },
  generatePreInvoice (context, data) {
    return preInvoice.generatePreInvoice(data)
  }
}
